import React from 'react';
import {
  FaCheckCircle,
  FaCircle,
  FaQuestionCircle,
  FaTimesCircle,
  FaUserCircle,
} from 'react-icons/fa';

const Stat = ({ icon, label, value, className }) => (
  <div className={`analysis-stat ${className || ''}`}>
    <div className="analysis-stat-icon">{icon}</div>
    <div>
      <strong>{value}</strong>
      <span>{label}</span>
    </div>
  </div>
);

const AnalysisSummary = ({
  email,
  answered,
  marked,
  visited,
  notAnswered,
  notVisited,
}) => (
  <section className="analysis-summary">
    <div className="profile-row">
      <div className="profile-avatar">
        <FaUserCircle />
      </div>
      <div>
        <span className="profile-label">Candidate</span>
        <strong title={email}>{email}</strong>
      </div>
    </div>

    <div className="summary-heading">
      <div>
        <span>Performance overview</span>
        <h2>Question Status</h2>
      </div>
      <FaQuestionCircle />
    </div>

    <div className="analysis-stats">
      <Stat
        icon={<FaCheckCircle />}
        label="Answered"
        value={answered}
        className="answered"
      />
      <Stat
        icon={<FaCircle />}
        label="Marked"
        value={marked}
        className="marked"
      />
      <Stat
        icon={<FaQuestionCircle />}
        label="Not visited"
        value={notVisited}
        className="not-visited"
      />
      <Stat
        icon={<FaTimesCircle />}
        label="Not answered"
        value={notAnswered}
        className="not-answered"
      />
    </div>

    <div className="status-legend">
      <span><i className="legend-dot answered" /> Answered</span>
      <span><i className="legend-dot marked" /> Marked</span>
      <span><i className="legend-dot visited" /> Visited</span>
    </div>
  </section>
);

export default AnalysisSummary;
